// node-modules
import isEmpty from 'lodash/isEmpty';
// typings
import { HoldingsLiveUpdate } from 'modules/TradesPW3/Holdings/typings';
// services
import { broker } from 'modules/TradingChart/consts';
import HoldingTvFormatter from 'modules/TradesPW3/Holdings/holdingsTv/HoldingTvFormatter';
import HoldingsService from './HoldingsService';
import WsPortfolioV2Feeder from '../../WebSocket/modules/PortfolioV2/store';

class HoldingsServiceUpdater {
  static registerHoldingUpdater() {
    WsPortfolioV2Feeder.registerHandler(
      'holding_update',
      (response: { data: HoldingsLiveUpdate }) => {
        if (!response?.data?.data) { return; }

        const { data } = response.data;

        if (isEmpty(data?.active)) return;

        const updatedHolding = HoldingsService.updateHoldings(data?.active[0]);

        if (!updatedHolding) { return; }

        const formattedHolding = HoldingTvFormatter
          .formatHoldingToTvTable(updatedHolding);

        if (broker.instance) {
          broker.instance.updateHoldings([formattedHolding]);
          broker.instance.updateHoldingsTotalPnL();
        }
      },
    );
  }
}

export default HoldingsServiceUpdater;
